import script from "./Groups2.vue?vue&type=script&setup=true&lang=ts"
export * from "./Groups2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__